module.exports = __webpack_public_path__ + "/login_ui/img/sl-3d739d073b37fbfcb6340b1c37f45a91.svg";